<template>
  <div
    v-if="title"
    class="section-statistics__tabs-header"
    :class="{ 'section-statistics__tabs-header--long-part': longTablePart }"
  >
    <i id="top-left-corner" />
    <button
      v-if="longTablePart"
      class="tabs-header__get-back-btn"
      @click="setLongTablePart(null)"
    >
      {{ $t("campaign.form.backToAllStatistics") }}
    </button>
    <div class="tabs-header__title-container">
      <h4 class="cm-title">
        {{ title }}
      </h4>
      <div>
        <spinner
          v-if="activeLoading"
          position="relative"
          class="spinner_small"
          :size="25"
          :center="false"
        />
        <CustomButtonSelect
          class="spinner_styles"
          :label="$t(`loyalty.controls.exportButton`)"
          :allow="!activeLoading"
          iconButton="export2"
          :options="selectOptions"
          @current="fileExport"
        />
      </div>
    </div>
  </div>
</template>

<script>
import long_table_mixin from "./long_table_mixin";
import export_statistic_mixin from "@/components/statistics/export_statistic_mixin";

export default {
  mixins: [long_table_mixin, export_statistic_mixin],

  props: {
    title: {
      type: String,
    },
  },

  methods: {
    gettingTabTitle(val) {
      const arrTabs = [
        {
          tabTitle: this.$t("campaign.forPeriod.delivery"),
          stateIdForBack: 2,
        },
        {
          tabTitle: this.$t("campaign.forPeriod.openings"),
          stateIdForBack: 4,
        },
        {
          tabTitle: this.$t("campaign.forPeriod.transitions"),
          stateIdForBack: 3,
        },
        {
          tabTitle: this.$t("campaign.forPeriod.unsubscribes"),
          stateIdForBack: 5,
        },
        {
          tabTitle: this.$t("campaign.forPeriod.errors"),
          stateIdForBack: 0,
        },
      ];

      return arrTabs.find((el) => new RegExp(`${el.tabTitle}`).test(`${val}`))
        .stateIdForBack;
    },
  },
};
</script>

<style lang="scss">
.spinner_styles {
  margin-left: 25px;
}
.spinner.spinner_small {
  position: absolute;
  left: 6px;
  top: 17px;
}
.section-statistics {
  &__tabs-header {
    margin: 0 20px 15px;
    max-width: auto;
    position: relative;

    #top-left-corner {
      left: -32px;
      top: 0;
      height: 0;
      display: inline-block;
      position: absolute;
    }

    .tabs-header {
      &__title-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .cm-title {
          line-height: 28px;
          margin: 20px 0;
        }
        .custom-button-select {
          display: inline-block;
          position: relative;
          top: -14px;
        }
      }
      &__get-back-btn {
        margin: 30px 0 0;
        padding: 0;
        @include linkBtn();
      }

      &--long-part {
        margin-bottom: 0;
      }
    }
  }
}
</style>
